module.exports = __webpack_public_path__ + "img/unit-testing-dashboard-1.1b6180b2.png";